import type { CSSObject } from '@emotion/react'

export const container: CSSObject = {
  alignItems: 'center',
  display: 'flex',
}
